import { Configuration, PopupRequest } from '@azure/msal-browser';

const getRedirectUri = () => {
  // If we are on localhost, we can use the env variable if present, otherwise fallback to current origin
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_REDIRECT_URI || window.location.origin + '/';
  }

  // In production (Azure SWA), we should ALWAYS use the current origin
  // This avoids baking in 'localhost' during the build process
  return window.location.origin + '/';
};

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '1f3b7612-f507-4fb1-8e85-f9b7547ae966',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || 'dbb488b6-7147-4fd8-b195-3bf51fab7f68'}`,
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getRedirectUri()
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
};

console.log('🚀 Redirect URI Source:', process.env.REACT_APP_REDIRECT_URI ? 'Environment Library' : 'Window Location Fallback');

console.log('🚀 REACT_APP_REDIRECT_URI from env:', process.env.REACT_APP_REDIRECT_URI);
console.log('🔑 Final MSAL Redirect URI:', msalConfig.auth?.redirectUri);
console.log('🌐 Window Origin:', window.location.origin);

if (msalConfig.auth?.redirectUri?.includes('azurestaticapps.net') && window.location.hostname === 'localhost') {
  console.warn('⚠️ WARNING: Redirect URI is set to PRODUCTION but you are on LOCALHOST!');
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read']
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphUsersEndpoint: 'https://graph.microsoft.com/v1.0/users'
};